import React from "react";
import { Box, Typography } from "@mui/material";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";

export default function WorkInProgress({ label }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 10,
        px: 2,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          backgroundColor: "#F3F4F6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <BuildOutlinedIcon sx={{ fontSize: 32, color: "#9CA3AF" }} />
      </Box>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: "#0D0D0E",
          mb: 0.5,
          fontFamily: "Inter Tight",
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: 13, color: "#6B7280" }}>
        Work in progress
      </Typography>
    </Box>
  );
}
